import {AuthHelper} from "./AuthHelper";
import {authService} from "../client/connection/Services";
import {DonationOfferStore, PaymentMethodStore} from "./State";
import {apiConnection} from "../client/connection/BlinkApiConnection";
import {apiCancelDonation} from "../client/state/DonationStore";
import {apiCancelSubscription, apiSubscribe} from "../client/state/SubscriptionStore";
import {authFormService} from "./services/AuthFormService";
import {donateMobileState} from "./paywall/inline-donation/DonateMobileState";
import {subscribeFlowState} from "./paywall/inline-subscription/SubscribeFlowState";
import {paymentMethodController} from "./paywall/inline-donation/PaymentMethodController";


class AutomationHelperClass {
    constructor() {
        donateMobileState.init(); // TODO: We need this, but not like this.
        subscribeFlowState.init(); // Same as above
    }

    async authenticate(userDetails = {email: "", firstName: "", lastName: ""}) {
        const automationEmailCode = "434343";
        const payload = {
            ...userDetails,
            withSignup: true,
            secure: false,
        };
        await AuthHelper.requestLoginCode(payload);
        if (authFormService.isRegistration) {
            return AuthHelper.confirmEmailByCode(automationEmailCode);
        } else {
            return AuthHelper.loginWithEmailCode(automationEmailCode);
        }
    }

    async addCard(cardDetails) {
        return apiConnection.post("/payment_methods/add_payment_method/", cardDetails);
    }

    async donate(payload) {
        const donationOffer = DonationOfferStore.all().find(offer => offer.id === payload.recurringOfferId);
        if (payload.preferredPaymentMethodId != null) {
            paymentMethodController.update({
                selectedPaymentMethod: PaymentMethodStore.get(payload.preferredPaymentMethodId)
            });
        }
        if (!donationOffer) {
            throw new Error(`Donation offer with id ${payload.recurringOfferId} not found.`);
        }
        donateMobileState.setPayload(payload);
        return await donateMobileState.donate();
    }

    async cancelDonation(donationId) {
        return apiCancelDonation(donationId);
    }

    async subscribe(subscriptionDetails) {
        return apiSubscribe(subscriptionDetails);
    }

    async cancelSubscription(subscriptionId) {
        return apiCancelSubscription(subscriptionId);
    }

    async addAddress(addressDetails) {
        return apiConnection.post("/user_addresses/create", addressDetails);
    }

    async logout() {
        return authService.logout();
    }
}

export const AutomationHelper = new AutomationHelperClass();
